import { createContext, useContext } from 'react';

import { DEFAULT_LANGUAGE, type Language } from './Language';
import { translate, type Translate } from './translate';

export type LanguageState = {
  language: Language;
  setLanguage: (next: Language) => void;
  t: Translate;
};

export const LanguageContext = createContext<LanguageState>({
  language: DEFAULT_LANGUAGE,
  setLanguage: () => undefined,
  t: (key, parameters) => translate(DEFAULT_LANGUAGE, key, parameters),
});

export const useLanguage = (): LanguageState => useContext(LanguageContext);

/** The function every component writes its words through. */
export const useT = (): Translate => useContext(LanguageContext).t;
